import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Text } from "../text/Text";
import "./List.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, fetchSettings } from "../../redux/internal";
import { useEffect } from "react";

type ListProps = {
  list: string[];
  className?: string;
  type?: string;
};

export const List = (props: ListProps) => {
  const { list, className, type } = props;
  const { t } = useTranslation();
  const { settings } = useSelector((state: RootState) => state.settings);
  const dispatch = useDispatch<AppDispatch>();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const recordLimit = settings && settings?.webApp?.bulkUser?.maxAllowedLimit;

  useEffect(() => {
    !settings && void dispatch(fetchSettings());
  }, [settings, dispatch]);

  return (
    <div className={classnames(className)}>
      {list.map((item, index) => (
        <div key={index} className="list">
          {type === "ordered" ? (
            <Text lKey={t(`${index + 1}.`)} className="list-number" />
          ) : (
            <Text lKey="." className="list-bullet" />
          )}
          <Text
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            lKey={index === 0 ? t(item, { placeholder: recordLimit }) : t(item)}
            className="list-item"
          />
        </div>
      ))}
    </div>
  );
};
